<template>
  <div class="col-sm-12 nopads">
    <div class="col-sm-12 editor-form">
      <h2 class="editor-header">{{ modelUpdate.id > 0 ?  $t('pricing_model_conversion.edit_mode') : $t('pricing_model_conversion.add_mode') }}</h2>
      <div class="col-sm-12 form-data nopads">
        <span class="span-title">{{ $t('pricing_model_conversion.code') }}</span>
        <multiselect
          v-model="code"
          :options="forestCodeOptions"
          :multiple="false"
          :close-on-select="true"
          label="text"
          maxHeight="180"
          track-by="value"
          :searchable="true"
          :selected-label="$t('common.selected')"
          :select-label="$t('common.select')"
          :deselect-label="$t('common.remove_selection')"
          :placeholder="$t('pricing_model_conversion.select_code')"
          :disabled="loading"
        >
          <template
            #singleLabel="props"
          >
            <span class="option__desc">
              <span class="option__title">{{ props.option.text }}</span>
            </span>
          </template>
          <template
            #option="props"
          >
            <div class="option__desc">
              <span class="option__title multiselect_detail_block">{{ props.option.text }}</span>
            </div>
          </template>
          <template #noResult>
            <span>{{ $t('common.not_found') }}</span>
          </template>
          <template #noOptions>
            <span>{{ $t('common.no_results') }}</span>
          </template>
        </multiselect>
        <span class="span-title">{{ $t('account.account') }}</span>
        <multiselect
          v-model="account"
          :options="accountOptions"
          :multiple="false"
          :close-on-select="true"
          label="text"
          track-by="value"
          maxHeight="160"
          :searchable="true"
          :selected-label="$t('common.selected')"
          :select-label="$t('common.select')"
          :deselect-label="$t('common.remove_selection')"
          :placeholder="$t('account.select_account')"
          :disabled="loading"
        >
          <template
            #singleLabel="props"
          >
            <span class="option__desc">
              <span class="option__title">{{ props.option.text }}</span>
            </span>
          </template>
          <template
            #option="props"
          >
            <div class="option__desc">
              <span class="option__title multiselect_detail_block">{{ props.option.text }}</span>
            </div>
          </template>
          <template #noResult>
            <span>{{ $t('common.not_found') }}</span>
          </template>
          <template #noOptions>
            <span>{{ $t('common.no_results') }}</span>
          </template>
        </multiselect>

          <span class="span-title">{{ $t('contracts.contract_class.title') }}</span>
          <multiselect
              v-model="contractClass"
              :options="contractClassOptions"
              :multiple="false"
              :close-on-select="true"
              label="text"
              track-by="value"
              maxHeight="160"
              :searchable="true"
              :selected-label="$t('common.selected')"
              :select-label="$t('common.select')"
              :deselect-label="$t('common.remove_selection')"
              :placeholder="$t('account.select_account')"
              :disabled="loading"
          >
              <template
                  #singleLabel="props"
              >
            <span class="option__desc">
              <span class="option__title">{{ props.option.text }}</span>
            </span>
              </template>
              <template
                  #option="props"
              >
                  <div class="option__desc">
                      <span class="option__title multiselect_detail_block">{{ props.option.text }}</span>
                  </div>
              </template>
              <template #noResult>
                  <span>{{ $t('common.not_found') }}</span>
              </template>
              <template #noOptions>
                  <span>{{ $t('common.no_results') }}</span>
              </template>
          </multiselect>

          <div class="col-sm-12 text-end my-2" style="padding-top: 6em">
          <button class="btn btn-secondary form-button" @click.stop="$emit('close')">
            {{ $t('common.cancel') }}
          </button>
          <button class="btn btn-success form-button" :disabled="loading || !code || !account || !code.value || !account.value" @click.stop="submit">
             {{ $t('common.save') }}
          </button>
        </div>
      </div>
    </div>
    <div
      v-if="loading"
      id="loader"
      class="spinner"
    />
    <base-modal v-if="deletion" @ok="deleteConversionModel()" @close="deletion = false">
      <div class="modal-body">
        <span>{{ $t('common.confirm_delete') }}</span>
      </div>
    </base-modal>
  </div>
</template>

<script>
import {conversionModelHelper} from '@/components/mixins/ConversionMixin'
import {restApi} from '@/components/mixins/RestApiMixin'
import BaseModal from "@/components/BaseModal";
import {inject} from "vue";

export default {
    name: 'ConversionAccountModelEditor',
    components: {BaseModal},
    mixins: [conversionModelHelper, restApi],
    props: {
        model: {
            type: Object,
            default: null
        },
        conversionModels: {
            type: Array,
            default() {
                return []
            }
        },
        codes: {
            type: Array,
            default() {
                return []
            }
        }
    },
    setup() {
        // Inject parents alerter
        const showAlert = inject('showAlert');
        return { showAlert };
    },
    data: function () {
        return {
            loading: false,
            code: null,
            deletion: false,
            account: null,
            accounts: [],
            accountOptions: [],
            contractClass: null,
            contractClasses: [],
            contractClassOptions: [],
            modelUpdate: this.jsonToItem(this.model),
        }
    },

    computed: {
        forestCodeOptions() {
            const nullVal = { value: null, text: this.$t('tasktypes.conversion.select_code') }
            if ((!this.codes || !Object.keys(this.codes).length) || this.loading) {
                return [nullVal]
            }
            // Sort by code
            this.codes.sort((a, b) => a.code - b.code);
            return [
                nullVal,
                ...this.codes.map(item => ({
                    value: item.code,
                    id: item.id,
                    text: item.code + ' - ' + item.name
                }))
            ]
        },
    },
    mounted: function () {
        this.fetchAccounts()
        this.fetchContractClasses()
        if (this.modelUpdate.id > 0) {
            if (this.modelUpdate.code && this.modelUpdate.code.id) {
                let foundCode = this.codes.find(item => item.id === this.modelUpdate.code.id)
                if (foundCode) {
                    this.code = {text: foundCode.name + ' ' + '(' + foundCode.code + ')', value: foundCode.code, id: foundCode.id}
                }
            }
        }
    },

    methods: {
        fetchAccounts: function () {
            this.loading = true
            this.restFetchParams(this.accountUrl, {state: 1}, this.handleAccountsSuccess)
        },

        handleAccountsSuccess: function (response) {
            this.accounts = response.data
            this.handleAccounts()
            this.loading = false
        },

        handleAccounts() {
            this.accountOptions = []
            // set empty option value
            this.accountOptions.push({text: this.$t('account.select_account'), value: null})
            this.accounts && this.accounts.forEach(account => {
                if(this.modelUpdate.account && this.modelUpdate.account.id && account.id === this.modelUpdate.account.id) {
                    // set preselected pricing model
                    this.account = {text: account.name, value: account.id}
                }
                this.accountOptions.push({text: account.name, value: account.id})
            })
        },

        fetchContractClasses() {
            this.loading = true
            this.restFetch(this.contractClassUrl, this.handleContractClassSuccess)
        },

        handleContractClassSuccess: function (response) {
            this.contractClasses = response.data
            this.handleContractClasses()
            this.loading = false
        },

        handleContractClasses() {
            this.contractClassOptions = []
            // set empty option value
            this.contractClassOptions.push({text: this.$t('contracts.contract_class.select_class'), value: null})
            this.contractClasses && this.contractClasses.forEach(contractClass => {
                if(this.modelUpdate.contract_class && this.modelUpdate.contract_class.id && contractClass.id === this.modelUpdate.contract_class.id) {
                    // set preselected pricing model
                    this.contractClass = {text: contractClass.name, value: contractClass.id}
                }
                this.contractClassOptions.push({text: contractClass.name, value: contractClass.id})
            })
        },

        setDefaultValues: function (model) {
            if (!this.code || !this.code.value) {
                this.showAlert(this.$t('tasktypes.conversion.invalid_code'))
                return undefined
            }
            if (!this.account || !this.account.value) {
                this.showAlert(this.$t('account.invalid_account'))
                return undefined
            }
            if(this.code && this.code.id) {
                model.code = this.codes.find(item => item.id === this.code.id)
            }
            if(this.account) {
                model.account = this.accounts.find(item => item.id === this.account.value)
            }
            if(this.contractClass) {
                model.contract_class = this.contractClasses.find(item => item.id === this.contractClass.value)
            }
            if(this.checkForDuplicates(model)) {
                this.showAlert(this.$t('tasktypes.conversion.duplicate_conversion'))
                return undefined
            }
            return model
        },

        submit: function () {
            let json = this.setDefaultValues(this.modelUpdate)
            if (json !== undefined) {
                this.loading = true
                if (this.modelUpdate.id < 1) {
                    this.restAdd(this.accountConversionUrl, json, this.success, this.fail)
                } else {
                    this.restUpdate(this.accountConversionUrl, json, this.success, this.fail)
                }
            }
        },

        checkForDuplicates(updateModel) {
            if (!this.conversionModels ) return false
            // require code and contractClass on the updateModel to enforce rule
            if (!updateModel || !updateModel.code || !updateModel.account) return false

            const updCodeId = updateModel.code.id
            const updClassId = updateModel.contract_class ? updateModel.contract_class.id : null
            const updAccountId = updateModel.account && updateModel.account.id

            const exist = this.conversionModels.find(cModel =>
                cModel.code && cModel.code.id === updCodeId &&
                (
                    (cModel.contract_class && updClassId != null && cModel.contract_class.id === updClassId) ||
                    (!cModel.contract_class && updClassId == null)
                ) &&
                cModel.id !== updateModel.id
            )
            return !!exist
        },

        success: function () {
            this.$emit('closeAndUpdate')
            this.loading = false
        },

        fail: function () {
            this.showAlert(this.$t('common.alert_update_failed'))
            this.loading = false
        }

    }
}
</script>
